import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

/**
 * Formats a date.  ex. Jan 1, 2024
 * @param d
 * @returns
 */
export function formatDate(d: Date): string {
  try {
    return format(d, 'MMM d, yyyy')
  } catch (e) {
    console.warn('Failed to format date', d)
    return ''
  }
}

/**
 * Formats a date string.  ex. Jan 1, 2024
 * @param s
 * @returns
 */
export function formatDateString(s: string): string {
  try {
    return formatDate(parseISO(s))
  } catch (e) {
    console.warn('Failed to format date string', s)
    return ''
  }
}

/**
 * Formats a date range.  ex. Dec 1 - Dec 5, 2024
 * @param startDateString
 * @param endDateString
 * @param separator
 * @returns
 */
export function formatDateRange(
  startDateString: string,
  endDateString: string,
  separator: string = '-'
): string {
  try {
    const startDate = parseISO(startDateString)
    const formattedStartDate = format(startDate, 'MMM d')
    const endDate = parseISO(endDateString)
    const formattedEndDate = format(endDate, 'MMM d, yyyy')
    return `${formattedStartDate} ${separator} ${formattedEndDate}`
  } catch (e) {
    console.warn('Failed to parse and format date range', {
      startDateString,
      endDateString
    })
    return ''
  }
}

/**
 * Formats a date as a day and date time.  ex. Wed, Dec 1, 2024 3:30 PM
 * @param dateString
 * @returns
 */
export function formatDayAndDateTime(dateString: string): string {
  try {
    const date = parseISO(dateString)
    return format(date, 'EEE, MMM d yyyy, h:mm a')
  } catch (e) {
    console.warn('Failed to format date with options', dateString)
    return ''
  }
}
